/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NetworkStatusCheckService } from 'utils/lib/network-status-check/network-status-check.service';
import { NvRequestOptions, NvHttpEndpoint, NetworkHttpEndpointRetryConfig } from '../nv-http-endpoint/nv-http-endpoint';

@Injectable({
    providedIn: 'root'
})
export class NvHttpEndpointFactoryService {
    constructor(
        private http: HttpClient,
        private networkStatusService: NetworkStatusCheckService,
        private networkHttpEndpointRetryConfig: NetworkHttpEndpointRetryConfig
    ) {}
    createEndpoint<T extends NvRequestOptions>(params?: T): NvHttpEndpoint {
        const endpoint = new NvHttpEndpoint(
            this.http,
            this.networkStatusService,
            params,
            this.networkHttpEndpointRetryConfig
        );
        return endpoint;
    }
}
